import { Box, chakra, ImageUploadOutline, rem } from '@bonusly/design-system';

import { CelebrationType } from '../../schemas/celebrations';
import { ReactComponent as BirthdayImage } from './assets/birthday-post.svg';
import { ReactComponent as CelebrationIcon } from './assets/celebration-icon.svg';
import { ReactComponent as NewHireImage } from './assets/new-hire-post.svg';
import { ReactComponent as WelcomeImage } from './assets/welcome-post.svg';
import { ReactComponent as WorkAnniversaryImage } from './assets/work-anniversary-post.svg';

const DefaultIcon = chakra(CelebrationIcon);
const ChakraBirthdayImage = chakra(BirthdayImage);
const ChakraWorkAnniversaryImage = chakra(WorkAnniversaryImage);
const ChakraNewHireImage = chakra(NewHireImage);
const ChakraWelcomeImage = chakra(WelcomeImage);
const ChakraImageUploadOutline = chakra(ImageUploadOutline);

export const getCelebrationStyles = (type: CelebrationType) => {
	switch (type) {
		case CelebrationType.Custom:
			return {
				bgColor: 'bg.surface',
				iconComponent: <Box bgColor="secondary.bgAlpha" w={10} h={10} />,
				imageComponent: <Box bgColor="secondary.bgAlpha" w={rem(284)} h={rem(284)} />,
			};

		case CelebrationType.Birthday:
			return {
				bgColor: 'bg.surface',
				iconComponent: <DefaultIcon w={10} h={10} />,
				imageComponent: <BirthdayImage />,
			};

		case CelebrationType.WorkAnniversary:
			return {
				bgColor: 'bg.surface',
				iconComponent: <DefaultIcon w={10} h={10} />,
				imageComponent: <WorkAnniversaryImage />,
			};

		case CelebrationType.NewHire:
			return {
				bgColor: 'bg.surface',
				iconComponent: <DefaultIcon w={10} h={10} />,
				imageComponent: <NewHireImage />,
			};

		case CelebrationType.Welcome:
			return {
				bgColor: 'bg.surface',
				iconComponent: <DefaultIcon w={10} h={10} />,
				imageComponent: <WelcomeImage />,
			};

		default:
			return {
				bgColor: 'bg.surface',
				iconComponent: null,
				imageComponent: null,
			};
	}
};

export const getDefaultIcon = (type: CelebrationType) => {
	if (type === CelebrationType.Custom) {
		return ChakraImageUploadOutline;
	}

	return DefaultIcon;
};

export const getDefaultImage = (type: CelebrationType) => {
	switch (type) {
		case CelebrationType.Birthday:
			return ChakraBirthdayImage;
		case CelebrationType.WorkAnniversary:
			return ChakraWorkAnniversaryImage;
		case CelebrationType.NewHire:
			return ChakraNewHireImage;
		case CelebrationType.Welcome:
			return ChakraWelcomeImage;
		default:
			return ChakraImageUploadOutline;
	}
};
